export default {"src":"/_next/static/media/column-off.0bce7b86.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};